import API from "@/services/api";  // nithin

const BASE_URL = "verve-contacts";

const parseResponse = (response) => response?.data?.data ?? response?.data ?? response;

export const verveContactService = {
  getContacts: async (params) => {
    const response = await API.get(BASE_URL, { params });
    return parseResponse(response);
  },

  getContactById: async (id) => {
    const response = await API.get(`${BASE_URL}/${id}`);
    return parseResponse(response);
  },

  createContact: async (data) => {
    const response = await API.post(BASE_URL, data);
    return parseResponse(response);
  },

  updateContact: async (id, data) => {
    const response = await API.patch(`${BASE_URL}/${id}`, data);
    return parseResponse(response);
  },

  deleteContact: async (id) => {
    const response = await API.delete(`${BASE_URL}/${id}`);
    return parseResponse(response);
  },

  getToday: async (params) => {
    return await verveContactService.getContacts({ ...params, date: 'today' });
  },

  getThisWeek: async (params) => {
    return await verveContactService.getContacts({ ...params, date: 'this_week' });
  },

  getThisMonth: async (params) => {
    return await verveContactService.getContacts({ ...params, date: 'this_month' });
  },

  getThisYear: async (params) => {
    return await verveContactService.getContacts({ ...params, date: 'this_year' });
  },

  getCustomRange: async (fromDate, toDate, params) => {
    return await verveContactService.getContacts({ ...params, fromDate, toDate });
  },

  getImportHistory: async () => {
    const response = await API.get(`${BASE_URL}/import-history`);
    return parseResponse(response);
  },

  getStats: async (params) => {
    const response = await API.get(`${BASE_URL}/stats`, { params });
    return parseResponse(response);
  },

  getActivityStats: async (params) => {
    const response = await API.get(`${BASE_URL}/stats/activity`, { params });
    return parseResponse(response);
  },

  bulkImport: async (data) => {
    const response = await API.post(`${BASE_URL}/bulk-import`, data);
    return parseResponse(response);
  },

  deleteImport: async (id) => {
    const response = await API.delete(`${BASE_URL}/import-history/${id}`);
    return parseResponse(response);
  },

  getUnassignedCityStats: async () => {
    const response = await API.get(`${BASE_URL}/unassigned-stats`);
    return parseResponse(response);
  },

  allocateContacts: async (allocations) => {
    const response = await API.post(`${BASE_URL}/allocate`, { allocations });
    return parseResponse(response);
  }
};
